import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AssetStatus } from 'src/app/models/assetStatus.model';
import { PermissionsEnum } from 'src/app/models/role.model';
import { BPSAdminLevel } from 'src/app/models/user.model';
import { AssetStatusService } from 'src/app/services/asset-status.service';
import { PermissionsService } from 'shared-lib';
import { TranslationUtils } from 'src/assets/i18n/translation.utils';

@Component({
  selector: 'crud-asset-status',
  templateUrl: './crud-asset-status.component.html',
  styleUrls: ['./crud-asset-status.component.scss'],
})
export class CrudAssetStatusComponent implements OnInit {
  public PermissionsEnum = PermissionsEnum;
  assetStatus: AssetStatus[] = [];

  public currentPage: number = 1;
  public pageSize: number = 5;
  public count: number = 0;

  selectedAssetStatus: AssetStatus = new AssetStatus();
  actionLabel$!: Observable<string>;
  isEditMode: boolean = false;

  @ViewChild('closeModal') closeModal: ElementRef;

  @Input() searchText!: string;
  @Input() utilityId: number = 0;
  @Input() bpsAdminLevel!: BPSAdminLevel;

  constructor(
    private assetStatuService: AssetStatusService,
    public permissionsService: PermissionsService,
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    if (this.utilityId != 0) {
      this.reloadTable();
    }

    this.updateActionLabel();
  }

  private updateActionLabel(): void {
    const key = this.isEditMode ? TranslationUtils.EDIT_KEY : TranslationUtils.NEW_KEY;
    this.actionLabel$ = this.translateService.stream(key);
  }

  filter() {
    this.currentPage = 1;
    let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {
        SearchValue: this.searchText,
      },
      utilityId: this.utilityId,
    };
    this.getAllAssetStatus(dataIn);
  }

  reloadTable(searchText?: string, page: any = null) {
    if (page) {
      this.currentPage = page;
    }

    let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {
        SearchValue: searchText,
      },
      utilityId: this.utilityId,
    };

    this.getAllAssetStatus(dataIn);
  }

  addNew() {
    this.isEditMode = false;
    this.selectedAssetStatus = new AssetStatus();
    this.updateActionLabel();
  }

  selectAssetStatus(assetStatus: AssetStatus) {
    this.isEditMode = true;
    this.selectedAssetStatus = { ...assetStatus };
    this.updateActionLabel();
  }

  pageChange(value: any) {
    this.currentPage = value;
    this.reloadTable(this.searchText);
  }

  save() {
    this.selectedAssetStatus.utilityId = this.utilityId;
    this.assetStatuService.save(this.selectedAssetStatus).subscribe({
      next: (response) => {
        if (response.status === 200 || response.status === 'OK') {
          this.closeModal?.nativeElement?.click();
          this.toastr.success(response.message);
          if (this.selectedAssetStatus.id === 0) {
            this.pageChange(1);
            return;
          }
          this.reloadTable(this.searchText);
        } else {
          this.toastr.error(response.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  deleteAssetStatus() {
    this.assetStatuService.delete(this.selectedAssetStatus.id).subscribe({
      next: (response) => {
        this.closeModal?.nativeElement?.click();
        if (response.status === 200 || response.status === 'OK') {
          this.pageChange(1);
          this.toastr.success(response.message);
        } else {
          this.toastr.error(response.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  private getAllAssetStatus(dataIn: any) {
    this.assetStatuService.getAll(dataIn).subscribe({
      next: (response) => {
        this.assetStatus = response.data.data;
        this.count = response.data.count;
        if (this.count == 0) {
          this.toastr.info('No data for given input.');
        }
      },
      error: (_) => this.toastr.error('An error ocurred.'),
    });
  }
}
